import { render, staticRenderFns } from "./ProgramPill.vue?vue&type=template&id=dcf94012&scoped=true&"
import script from "./ProgramPill.vue?vue&type=script&lang=ts&"
export * from "./ProgramPill.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramPill.vue?vue&type=style&index=0&id=dcf94012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf94012",
  null
  
)

export default component.exports